<template>
  <button
    class="custom-button"
    :class="[variant]"
    @click="$emit('click')"
  >
    <slot name="icon" />
    <span class="button-text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary'].includes(value)
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-button {
  width: 100%;
  height: 50px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  font-family: Vollkorn;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: center;
  color: white;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.custom-button:active {
  opacity: 0.8;
}

.primary {
  background-color: $woi-gold-main;
}

.secondary {
  background-color: $brand-primary-color;
}
</style>
